import CenteredLoadingAnimation from './CenteredLoadingAnimation';
export default CenteredLoadingAnimation;



// WEBPACK FOOTER //
// ./src/components/CenteredLoadingAnimation/index.js